import MarketingView from 'views/Marketing'

const Marketing = () => <MarketingView />

export default Marketing
